import React, { FC } from 'react'
import styled from 'styled-components'
import { createResource, useResource } from '../../lib/i18n'
import { useWindowSize } from '../../lib/use-hooks/use-window-size'

const resource = createResource({
  id: {
    intrucationTitle: 'Dapatkan Pinjaman Tunai Cepat Cair Hanya dari Aplikasi Kredit Pintar',
    intruckey1:
      'Kredit Pintar adalah aplikasi yang menyediakan layanan pinjaman uang online untuk mendukung inklusi keuangan dengan nama badan usaha PT. Kredit Pintar Indonesia yang telah berdiri sejak tahun 2018.',
    intruckey2:
      'Kredit Pintar telah terdaftar dan diawasi oleh OJK, sehingga dinyatakan sebagai penyedia layanan pinjaman uang online yang resmi beroperasi di Indonesia.',
    intruckey3:
      'Dengan memanfaatkan teknologi Artificial Intelligence terdepan, Kredit Pintar memberikan kemudahaan bagi penggunanya untuk mendapatkan pinjaman tanpa angunan melalui aplikasi Kredit Pintar, dengan proses pengajuan cepat hanya menggunakan KTP. ',
    intruckey4:
      'Kemudahan pengajuan pinjaman tersebut, bisa dinikmati oleh seluruh masyarakat Indonesia, karena pinjaman uang online dari Kredit Pintar telah mencakup seluruh wilayah Indonesia.',
    intruckey5:
      'Untuk ajukan pinjaman tunai cepat cair, Anda bisa download dan install aplikasi resmi Kredit Pintar yang tersedia di Google Play Store.',
    intruckey6:
      'Hingga saat ini, Kredit Pintar telah diunduh lebih dari 10 juta kali dengan 1,5 juta ulasan pelanggan di Google Play Store dan memiliki penilaian bintang 4.8 dari 5.',
    avilableTitle: 'Nominal dan Tenor Pinjaman Yang Tersedia',
    availablekey1: '-Rp 600.000, dengan tenor 2 bulan',
    availablekey2: '-Rp 1.200.000, dengan tenor 2 bulan.',
    availablekey3: '-Rp 1.800.000, dengan tenor 2 bulan.',
    availablekey4: '-Rp 2.300.000, dengan tenor 3 bulan.',
    availablekey9: '-Rp 6.000.000, dengan tenor 6 bulan.',
    availablekey10: '-Rp 12.000.000, dengan tenor 12 bulan.',
    availablekey5:
      'Jumlah pinjaman kami berkisar mulai dari Rp 600.000,- hingga Rp 10.000.000,- dalam sekali transaksi.',
    availablekey6: 'Tingkatkan skor kredit dan dapatkan pinjaman hingga 5, 10, hingga 50 juta Rupiah tanpa jaminan.',
    availablekey7: 'Fleksibel, pelunasan dapat dilakukan dengan cicilan bulanan. ',
    availablekey8: 'Dapatkan pinjaman tunai dengan cicilan 2,3,6, dan 12 bulan SEKARANG!',
    availableAmount: 'Jumlah pinjaman',
    availableTenor: 'Tenor Pinjaman',
    tcTitle: 'Syarat dan Ketentuan Pengajuan Pinjaman di Kredit Pintar',
    tskey1:
      'Agar bisa pinjam dana tunai melalui aplikasi Kredit Pintar, nasabah harus mematuhi persyaratan sebagai berikut.',
    tskey2: '1. Warga Negara Indonesia',
    tskey3: '2. Usia 18 – 55 tahun atau minimum Usia 22, maksimum 60 tahun',
    tskey4: '3. Memiliki KTP yang masih berlaku',
    tskey5: '4. Memiliki akun Bank sesuai dengan KTP',
    tskey6: '5. Berdomisili di Indonesia',
    tskey7: '6. Melengkapi data dan dokumen lain yang diperlukan.',
  },
  en: {
    intrucationTitle: 'Get a cash loan with instant disbursement only from Kredit Pintar application.',
    intruckey1:
      'Kredit Pintar is an application that provides online cash loan service to support financial inclusion, under PT. Kredit Pintar Indonesia business entity that has been established since 2018.',
    intruckey2:
      'Kredit Pintar is already registered and supervised by the Authorities of Financial Services (OJK), so it is stated as an online cash loan provider that is legally operated in Indonesia.',
    intruckey3:
      'By utilizing the latest Artificial Intelligence technology, Kredit Pintar provides convenient unsecured cash loan for the user via Kredit Pintar application, quick application process only using ID Card.',
    intruckey4:
      'The ease in applying for a loan can be experienced by the entire Indonesia citizens, since the mortgage-free loan Kredit Pintar has included all areas in Indonesia.',
    intruckey5:
      'To apply for an instant disbursement loan, you can download and install the verified Kredit Pintar application available in Google Play Store.',
    intruckey6:
      'Until now, Kredit Pintar has been downloaded for more than 10 million times with 1.5 million customer reviews in Google Play Store and has 4.8 out of 5 stars rating.',
    avilableTitle: 'Available Loan Amount and Tenor',
    availablekey1: '-Rp 600.000, with 2 months tenor.',
    availablekey2: '-Rp 1.200.000, with 2 months tenor.',
    availablekey3: '-Rp 1.800.000, with 2 months tenor.',
    availablekey4: '-Rp 2.300.000, with 3 months tenor.',
    availablekey9: '-Rp 6.000.000, with 6 months tenor.',
    availablekey10: '-Rp 12.000.000, with 12 months tenor.',
    availablekey5: 'Our loan amount range is from Rp 600.000,- until Rp 10.000.000,- in a single transaction.',
    availablekey6:
      'Improve the credit history and get up to 5 million Rupiahs, 10 million Rupiahs, until 50 million Rupiahs loan without mortgage.',
    availablekey7: 'Stress-free, repayment can be done in monthly installment.',
    availablekey8: 'Get cash loan with 2, 3, 6 and 12 months of installment NOW!',
    availableAmount: 'Loan amount',
    availableTenor: 'Loan Tenor',
    tcTitle: 'T&C to apply for a loan in Kredit Pintar.',
    tskey1:
      'In order to be able to apply for a cash loan through Kredit Pintar application, the customers must fulfill the terms and conditions as below.',
    tskey2: '1. Indonesia Citizen',
    tskey3: '2. Age between 18-55 years old or at least 22 years old, maximum 60 years old.',
    tskey4: '3. Has a valid Indonesian ID Card.',
    tskey5: '4. Bank account that is synchronized with Indonesian ID Card.',
    tskey6: '5. Live in Indonesia',
    tskey7: '6. Fulfill another necessary data and documents.',
  },
})

type IProps = {}

const Intrucation: FC<IProps> = (props: IProps) => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()

  const cashLoanMethods: string[] = ['intruckey1', 'intruckey2', 'intruckey3', 'intruckey4', 'intruckey5', 'intruckey6']
  const availableLoanTop: string[] = [
    'availablekey1',
    'availablekey2',
    'availablekey3',
    'availablekey4',
    'availablekey9',
    'availablekey10',
  ]
  const availableLoanCenter: string[] = ['availablekey5', 'availablekey6']
  const availableLoanBottom: string[] = ['availablekey7', 'availablekey8']
  const tcList: string[] = ['tskey1', 'tskey2', 'tskey3', 'tskey4', 'tskey5', 'tskey6', 'tskey7']
  return (
    <IntrucationStyles>
      {width > 1000 ? (
        <div className="intrucation-pc">
          <h3 className="intrucation-title">{t('intrucationTitle')}</h3>
          {cashLoanMethods.map((item: string) => (
            <div className="cash-loan" key={item}>
              {t(item as any)}
            </div>
          ))}
          <h3 className="avilable-title">{t('avilableTitle')}</h3>
          {availableLoanTop.map((item) => (
            <div className="cash-loan" key={item}>
              {t(item as any)}
            </div>
          ))}
          <p className="available-amount">{t('availableAmount')}</p>
          {availableLoanCenter.map((item) => (
            <div className="cash-loan" key={item}>
              {t(item as any)}
            </div>
          ))}
          <p className="available-tenor">{t('availableTenor')}</p>
          {availableLoanBottom.map((item) => (
            <div className="cash-loan" key={item}>
              {t(item as any)}
            </div>
          ))}
        </div>
      ) : (
        <div className="intrucation-mobile">
          <h3 className="intrucation-title">{t('intrucationTitle')}</h3>
          {cashLoanMethods.map((item: string) => (
            <div className="cash-loan" key={item}>
              {t(item as any)}
            </div>
          ))}
          <h3 className="avilable-title">{t('avilableTitle')}</h3>
          {availableLoanTop.map((item) => (
            <div className="cash-loan" key={item}>
              {t(item as any)}
            </div>
          ))}
          <p className="available-amount">{t('availableAmount')}</p>
          {availableLoanCenter.map((item) => (
            <div className="cash-loan" key={item}>
              {t(item as any)}
            </div>
          ))}
          <p className="available-tenor">{t('availableTenor')}</p>
          {availableLoanBottom.map((item) => (
            <div className="cash-loan" key={item}>
              {t(item as any)}
            </div>
          ))}
        </div>
      )}
    </IntrucationStyles>
  )
}

export default Intrucation

const IntrucationStyles = styled.div`
  @media only screen and (min-width: 1000px) {
    .intrucation-pc {
      margin: 0 auto;
      max-width: 1440px;
      padding: 60px 150px 80px;
    }
  }
  @media only screen and (max-width: 1000px) {
    .intrucation-mobile {
      margin: 0 auto;
      padding: 32px 24px 18px;
    }
  }
  .intrucation-title,
  .avilable-title,
  .tc-title {
    font-size: 28px;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
    line-height: 36px;
    margin-bottom: 24px;
    margin-top: 48px;
  }
  .available-amount,
  .available-tenor {
    font-weight: 700;
  }
  .cash-loan {
    font-size: 16px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #212121;
    line-height: 20px;
    margin-bottom: 24px;
  }
`
